<template>
    <div class="head-notice" v-if="showNotice">
        <div class="notice c-c p" @click="notice()">
            <img src="../assets/images/images/voice2.png" alt="">
            <span class="f11 white t">1条新通知</span>
        </div>
    </div>
</template>

<script>
import { getData } from '../Interface/http';
export default {
    name: 'HeadNotice',
    data(){
        return {
            helpMes:{}
        }
    },
    methods:{
        notice(){
            this.$store.commit('HIDENOTICE')
            this.$store.commit('UPDATEARTICLEDETAIL',{articleDetail: this.helpMes});
             this.$router.push({ name: "articleDetail", params: { 
                detail: this.helpMes
            }});
        },
        getNotice(){
            getData('/article/notice').then(res=> {
                this.helpMes = res.data;
            })
        }
    },
    computed:{
        showNotice(){
            return this.$store.state.showNotice;
            
        }
    },
    mounted(){
        this.getNotice();
    }
}
</script>

<style scoped>
.head-notice {
    width: 100%;
    height: 28px;
    /* padding: 5px 0; */
    box-sizing: border-box;
    margin-top: -5px;
    margin-bottom: 5px;
}
.notice{
    width: 145px;
    height: 28px;
    margin: 0 auto;
    border-radius: 5px;
    background: rgb(102,102,102);
}
.p {
    /* flex-direction: column */
}
.p img {
    width:15px;
    height:15px;
}
.t {
    margin-left: 6px;
}
</style>
